import { LocationsService } from 'core/api/services/locations';
import { LoadStatesFunction } from './loadStates.type';

const loadStates: LoadStatesFunction = async ({
  countryId,
  onInit,
  onSuccess,
  onError,
  onFinally,
}) => {
  if (onInit) onInit();

  try {
    const states = await LocationsService.getStates(countryId);

    if (onSuccess) onSuccess(states);

    return states;
  } catch (error) {
    console.error(error);

    if (onError) onError(error);

    return [];
  } finally {
    if (onFinally) onFinally();
  }
};

export default loadStates;
